import React from 'react';
import sButtons from "../../../assets/styles/buttons.module.css";
import {toast} from "react-toastify";
import success = toast.success;

interface FormActionButtonProps {
    mode?: "success" | "danger"
    type?: "button" | "submit" | "reset" | undefined;
    onClick?: () => void;
    disabled?: boolean;
    text: string;
    className?: string;
}

export const FormActionButton : React.FC<FormActionButtonProps> = ({
    mode = "success",
                                                                type = "button",
                                                                onClick= ()=>{},
                                                                disabled,
                                                                className,
                                                                text
                                                            }) => {
    const buttonClassName = className
        ? `${mode === "success" ? sButtons.successButton : sButtons.dangerButton} ${className}`
        : mode === "success" ? sButtons.successButton : sButtons.dangerButton;
    return (
        <button
            type={type}
            className={buttonClassName}
            disabled={disabled}
            onClick={onClick}
        >
            {text}
        </button>
    )
};